import React, { useRef, useState, useEffect } from 'react';
import { ReactComponent as TargetUndo } from '../../assets/svg/undoTarget.svg';
import { ReactComponent as Save } from '../../assets/svg/Save.svg';
import '../../styles/modals/StudentInfoModal.css';
import { Controller, useForm } from 'react-hook-form';
import Loading from '../Loading';
import { useNavigate, useParams } from 'react-router-dom';
import MDEditor from '@uiw/react-md-editor';
import { editCourseCategory, editSolutionCategory, getCategoryById, getLocales, getSolutionCategoryById } from '../../server/server';
import { fileSystemUrl } from '../../server/connections';
import CategoriesDropDown from '../courses/CategoriesDropDown';
import { notify } from '../../utils/util';
import ImageComponent from '../ImageComponent';

function SingleSolutionCategoryScreen() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [hoveredButton, setHoveredButton] = useState(false);
	const [category, setCategory] = useState<any>(null);
	const [loading, setLoading] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [image, setImage] = useState<string | undefined>(undefined);
	const [imageId, setImageId] = useState('');
	const [locales, setLocales] = useState([]);
	const [locale, setLocale] = useState('Select');

	const { register, handleSubmit, watch, reset, formState, getValues, setValue, control } = useForm({
		defaultValues: {
			name: '',
			codeName: '',
			description: '',
			localeId: '',
			visible: true,
			userType: 'parent',
		},
	});
	const { isDirty, isValid, errors } = formState;

	useEffect(() => {
		loadLocales();
	}, []);

	useEffect(() => {
		if (id && id !== 'new') loadCategory(id);
	}, [id]);

	useEffect(() => {
		if (!!category?.id) {
			console.log(category);
			setValue('name', category?.name);
			setValue('codeName', category?.codeName);
			setValue('description', category?.description);
			setValue('visible', category?.visible);
			setValue('localeId', category.locale?.id);
			setValue('userType', category.userType);
			setLocale(category.locale?.name ?? 'Select');
		}
		if (!!category?.image) {
			setImage(fileSystemUrl + '/' + category.image?.url);
			setImageId(category?.image?.id);
		}
	}, [category]);

	const loadCategory = async (id: string) => {
		setLoading(true);
		const resp = await getSolutionCategoryById(id);
		if (resp.status == 200) {
			setCategory(resp.data);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	const loadLocales = async () => {
		const resp = await getLocales();
		if (resp.status === 200) {
			setLocales(resp.data);
		}
	};

	const onSubmit = async () => {
		if (category === null) {
			createCategory();
		} else {
			updateCategory();
		}
	};

	const createCategory = async () => {};

	const updateCategory = async (file: any = null) => {
		setProcessing(true);
		let newCategory: any = getValues();
		newCategory.id = category?.id;
		newCategory.imageId = imageId ?? null;

		const resp = await editSolutionCategory(newCategory);
		if (resp.status === 201) {
			const courseFresh = resp.data;
			notify('Category is updated!');
			setProcessing(false);
		} else {
			setProcessing(false);
		}
	};

	const toCamelCase = (str: string) => {
		// Ukloni razmake između reči
		const words = str.split(' ');
		const camelCaseString = words
			.map((word, index) => {
				// Prvu reč pretvori u mala slova
				if (index === 0) {
					return word.toLowerCase();
				}
				// Pretvori ostale reči u Pascal Case
				return word.charAt(0).toUpperCase() + word.slice(1);
			})
			.join('');

		return camelCaseString;
	};

	const setSelectedLocaleId = (item: any) => {
		setValue('localeId', item?.id, { shouldValidate: true });
		setLocale(!!item?.name ? item.name : 'Select');
	};

	return (
		<div className='flex h-full flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[40px]'>
			<div className=' w-full max-w-[1200px] px-[10px] '>
				<form onSubmit={handleSubmit(onSubmit)} className='w-full  bg-white flex flex-col px-[40px] py-[30px] rounded-[10px]'>
					{loading && (
						<div className='w-full flex flex-row items-center justify-center min-h-[600px]'>
							<Loading size={70} primaryColor='#5E639B' stroke={3} />
						</div>
					)}

					{!loading && (
						<div className='flex flex-col gap-5'>
							<div className='flex flex-row justify-between mt-5'>
								<div className='flex flex-row  gap-10'>
									<div className=' flex cursor-pointer mr-5 items-center justify-center bg-primaryViolet hover:bg-darkViolet  min-w-[56px] w-[56px] h-[56px] rounded-full' onClick={() => navigate(-1)} onMouseEnter={() => setHoveredButton(true)} onMouseLeave={() => setHoveredButton(false)}>
										<TargetUndo fill={hoveredButton ? '#FDDF6D' : '#FFFFFF'} />
									</div>
									<div className='flex-1'>
										<p className='text-primaryViolet font-semibold text-3xl text-left'>{category === null ? 'Create new category' : 'Edit solution category'}</p>
									</div>
								</div>
							</div>
							<div>
								<div className='flex flex-row gap-6 mt-1'>
									<div className='flex flex-col flex-1'>
										<div>
											<p className='text-primaryViolet font-semibold text-lg text-left'>Category name</p>
											<div className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.name?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
												<input className={`w-full text-primaryViolet ${errors.name?.type === 'required' ? 'placeholder:text-redError' : ''}`} placeholder={`Type category name`} {...register('name', { required: true })} style={{ backgroundColor: 'transparent' }} onChange={(e: any) => setValue('codeName', toCamelCase(e.target.value))} />
												<p className='text-redError   text-nowrap'>{errors.name?.type === 'required' ? '*This field is required' : ''}</p>
											</div>
										</div>
										<div className='mt-4'>
											<p className='text-primaryViolet font-semibold text-lg text-left'>Category code name</p>
											<div className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.codeName?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
												<input className={`w-full text-primaryViolet ${errors.codeName?.type === 'required' ? 'placeholder:text-redError' : ''}`} placeholder={`Type category code name`} {...register('codeName', { required: true })} style={{ backgroundColor: 'transparent' }} readOnly />
												<p className='text-redError   text-nowrap'>{errors.codeName?.type === 'required' ? '*This field is required' : ''}</p>
											</div>
										</div>
									</div>
									<ImageComponent image={image} setImage={setImage} imageId={imageId} setImageId={setImageId} />
								</div>
								<div className='mt-4'>
									<div className='flex flex-row items-end justify-between gap-5'>
										<p className={`text-primaryViolet font-semibold text-lg text-left ${errors.description?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}>Description</p>

										<p className='text-redError font-medium text-lg  '>{errors.description?.type === 'required' ? '* This field is required' : ''}</p>
									</div>
									<Controller control={control} name='description' rules={{ required: true }} render={({ field }) => <MDEditor data-color-mode='light' value={field.value} onChange={(value: any) => setValue('description', value, { shouldValidate: true })} preview='edit' />} />
								</div>
								<div className='mt-4'>
									<CategoriesDropDown list={locales} register={register} registerField='localeId' errors={errors.localeId?.type} label='Locales' selectedValue={locale} setSelectedValue={setSelectedLocaleId} />
								</div>
							</div>

							<div className='flex flex-row justify-end w-full gap-5'>
								{/* <div
									className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer rounded-full bg-[#fafaff]  h-[60px] button-transparent-class'
									onClick={() => navigate(-1)}
								>
									<p className='text-[18px] text-primaryViolet leading-5 font-semibold mr-3 '>Back</p>
								</div> */}
								<button className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer  rounded-full bg-primaryViolet  min-h-[60px] button-save-class transition' disabled={processing}>
									{processing ? (
										<Loading primaryColor='#FDDF6D' secondaryColor='#5E639B' size={25} stroke={7} />
									) : (
										<div className='flex flex-row items-center justify-center'>
											<p className='text-[18px]  leading-5 font-semibold mr-3 '>Save</p>
											<Save />
										</div>
									)}
								</button>
							</div>
						</div>
					)}
				</form>
			</div>
		</div>
	);
}

export default SingleSolutionCategoryScreen;
